import React from "react";
import { Link } from "react-router-dom";
import Parallax from "components/Parallax";
import BgImage from "components/BgImage";
import imgScene from "assets/images/scene-toaster-2.jpg";

class BrandNav extends React.Component {
  render = () => {
    const brandId = this.props.brand;
    let brandName;

    switch (brandId) {
      case "microdry":
        brandName = "Microdry";
        break;
      case "asko":
        brandName = "Asko";
        break;
      default:
        brandName = "morphy richards";
    }

    return (
      <section style={{ marginTop: "65px", padding: "0 0 30px" }}>
        {this.renderBrand(brandId, brandName)}
      </section>
    );
  };

  renderBrand = (brandId, brandName) => (
    <Parallax wrapperClass="bg-image-wrapper" imageClass="bg-image" step={200}>
      <BgImage src={imgScene} height="100px" overlay={{ opacity: 0.8 }}>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 text-left">
              <h3 style={{ lineHeight: "100px" }}>
                {brandName}
                <Link to={`/${brandId}/products`} className="brand-bar__link">
                  銷售商品
                </Link>
                {this.renderLink1(brandId)}
                {this.renderLink2(brandId)}
              </h3>
              {/* <p className="lead">Showcase a gallery of images with lightbox capability</p> */}
            </div>
          </div>
        </div>
      </BgImage>
    </Parallax>
  );

  renderLink1 = (brandId) => {
    switch (brandId) {
      case "asko":
        return (
          <Link to={`/${brandId}/brochures`} className="brand-bar__link">
            型錄
          </Link>
        );
      default:
      // return <Link to={`/${brandId}/stores`} className="brand-bar__link">購買據點</Link>
    }
  };

  renderLink2 = (brandId) => {
    switch (brandId) {
      // case "asko":
      //   return (
      //     <Link to={`/${brandId}/recipes`} className="brand-bar__link">
      //       食譜
      //     </Link>
      //   );
      default:
        return null;
    }
  };
}

export default BrandNav;



// WEBPACK FOOTER //
// ./src/components/BrandNav/index.js